__webpack_require__.p = "/Delight-Bakery/";